import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const PowerForceShutdown = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='PowerForceShutdown' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M12,8 L12,16' />
  </StyledIcon>
);
